import { Autocomplete, TextField } from "@mui/material"
import { useAppDispatch, useAppSelector } from "../../../app/hooks"
import { RootState } from "../../../app/store"
import { useEffect } from "react"
import { fetchUsersThunk } from "../../users-list/UserListSlice"
import UserInterface from "../../../app/models/user-interface"

interface UserSelectorAutocompleteProps {
  selectedUserId: string
  onUserChange: (userId: string) => void
  label?: string
  placeholder?: string
}

export default function UserSelectorAutocomplete({
  selectedUserId,
  onUserChange,
  label = "Usuario",
  placeholder = "Seleccionar usuario..."
}: UserSelectorAutocompleteProps) {
  const dispatch = useAppDispatch()
  const { users } = useAppSelector((state: RootState) => state.users)

  useEffect(() => {
    if (users.length === 0) {
      dispatch(fetchUsersThunk())
    }
  }, [dispatch, users.length])

  const handleUserChange = (_event: any, selectedUser: UserInterface | null) => {
    onUserChange(selectedUser?._id || "")
  }

  const getSelectedUser = (): UserInterface | null => {
    return users.find(user => user._id === selectedUserId) || null
  }

  const getUserDisplayName = (user: UserInterface): string => {
    const fullName = `${user.name} ${user.lastName}`.trim()
    return fullName || user.email || user.user || "Usuario sin nombre"
  }

  return (
    <Autocomplete
      options={users}
      getOptionLabel={(option) => getUserDisplayName(option)}
      value={getSelectedUser()}
      onChange={handleUserChange}
      renderInput={(params) => (
        <TextField
          {...params}
          label={label}
          placeholder={placeholder}
          variant="outlined"
          fullWidth
        />
      )}
      isOptionEqualToValue={(option, value) => option._id === value._id}
      noOptionsText="No se encontraron usuarios"
      loading={users.length === 0}
    />
  )
} 